import { normalizeTrack } from './trackModel';
import { applyFilterPreset } from './filterPresets';
import { countTrackSlots } from '@/state/classSession';

export function duplicateTrack(tracks, trackId, { maxTracks = 32, classSession = null, lowEndLayer = false, uuid = () => crypto.randomUUID() } = {}) {
  if (countTrackSlots(tracks, classSession) >= maxTracks) return { tracks, duplicated: null, reason: 'max-tracks' };
  const index = (tracks || []).findIndex((track) => track.id === trackId);
  if (index < 0) return { tracks, duplicated: null, reason: 'not-found' };
  const source = tracks[index];
  if (source.inBank) return { tracks, duplicated: null, reason: 'banked' };
  const loopIds = new Map();
  const clips = (source.clips || []).map((clip) => {
    const copy = structuredClone(clip); copy.id = `clip-${uuid()}`;
    if (copy.isPattern) {
      if (!loopIds.has(copy.loop_id)) loopIds.set(copy.loop_id, `pattern-${uuid()}`);
      copy.loop_id = loopIds.get(copy.loop_id);
      copy.pattern = structuredClone(clip.pattern);
    }
    return copy;
  });
  const duplicated = { ...structuredClone(source), id: `track-${uuid()}`, name: `${source.name} copy`, clips, classSlot: undefined, inBank: false };
  if (lowEndLayer) {
    duplicated.name = `${source.name} low end`;
    duplicated.volume = Math.round(normalizeTrack(source).volume * 0.5);
    duplicated.effects = applyFilterPreset({ ...source.effects, reverb: 0, echo: 0, punch: 0 }, 'lowEnd');
  }
  const next = [...tracks.slice(0, index + 1), duplicated, ...tracks.slice(index + 1)];
  return { tracks: next, duplicated, reason: null };
}

export function commitDuplicateTrack(pushState, { tracks, sectionMarkers = [] }, trackId, options) {
  const result = duplicateTrack(tracks, trackId, options);
  if (result.duplicated) pushState({ tracks: result.tracks, sectionMarkers });
  return result;
}
